import { render, staticRenderFns } from "./admin-system-statistics.vue?vue&type=template&id=3a660b48&scoped=true"
import script from "./admin-system-statistics.vue?vue&type=script&lang=js"
export * from "./admin-system-statistics.vue?vue&type=script&lang=js"
import style0 from "./admin-system-statistics.vue?vue&type=style&index=0&id=3a660b48&prod&lang=css"
import style1 from "./admin-system-statistics.vue?vue&type=style&index=1&id=3a660b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a660b48",
  null
  
)

export default component.exports